module.exports = __webpack_public_path__ + "img/log_branco_norven_big.a1882021.png";